module.exports = __webpack_public_path__ + "static/media/ceo.f100eebf.png";